import { History, Location } from "history";
import * as React from 'react';
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { match } from 'react-router';
import { routerActions } from 'react-router-redux';
import Alert from 'react-s-alert';
import { bindActionCreators } from "redux";
import * as GlioblastomaDetailFormActions from '../../../actions/forms/glioblastomaDetailForm';
import * as InstitutionActions from '../../../actions/institution';
import * as GlioblastomaDetailFormPageActions from '../../../actions/pages/registration/glioblastomaDetailFormPage';
import * as PatientActions from '../../../actions/patient';
import { NotificationAlert } from "../../../components/common/index";
import { CheckboxFormInput, NumberFormInput, RadioButtonSetFormInput, SelectFormInput, TextFormInput } from "../../../components/form/index";
import { DatePickerFormInputFabric } from '../../../components/form/inputs';
import { INavItem, RestrictedLayout } from "../../../components/layouts/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from '../../../dtos/Fig.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock, renderRegistrationFormSaveError, renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning } from "../../../helpers/alert";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { IFigState } from "../../../reducers/index";
import { IGlioblastomaDetailReduxFormState, initialGlioblastomaDetailFormState } from "../../../reducers/reactReduxForms/glioblastomaDetailForm";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { ISourceDocumentModalState } from "../../../reducers/reactReduxForms/sourceDocument";
import './GlioblastomaDetailFormPage.scss';

interface IGlioblastomaDetailFormPageParams {
    identifier: string;
    institutionCode: string;
}

interface IGlioblastomaDetailFormPageActions {

    loadGlioblastomaDetailForm: GlioblastomaDetailFormActions.IGlioblastomaDetailFormLoadByPatientIdentifierActionCreator,
    saveGlioblastomaDetailForm: GlioblastomaDetailFormActions.IGlioblastomaDetailFormSaveActionCreator,
    createGlioblastomaDetailForm: GlioblastomaDetailFormActions.IGlioblastomaDetailFormCreateActionCreator,
    clearGlioblastomaDetailForm: GlioblastomaDetailFormActions.IGlioblastomaDetailFormClearActionCreator,

    clearPatient: PatientActions.IPatientClearActionCreator;

    loadPatient: PatientActions.IPatientLoadByIdentifierActionCreator;
    loadPatientById: PatientActions.IPatientLoadByIdActionCreator;

    clearInstitution: InstitutionActions.IInstitutionClearActionCreator;

    loadInstitution: InstitutionActions.IInstitutionLoadByInstitutionCodeActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleMessageModal: GlioblastomaDetailFormPageActions.IGlioblastomaDetailFormPageToggleMessageModalActionCreator;
}

interface IGlioblastomaDetailFormPageProps {

    form: Dtos.GlioblastomaDetailForm & IRegistrationFormState & ISourceDocumentModalState;
    formState: Dtos.RegistrationFormState;
    formProperties: Dtos.RegistrationFormProperty[];
    reduxFormState: IGlioblastomaDetailReduxFormState;

    location: Location;
    match: match<IGlioblastomaDetailFormPageParams>;
    history: History;
    identifier: string;
    institutionCode: string;
    patient: Dtos.Patient;
    loadingPatient: boolean;
    loadPatientSuccess: boolean;
    loadPatientFailure: boolean;

    institution: Dtos.Institution;
    loadingInstitution: boolean;
    loadInstitutionSuccess: boolean;
    loadInstitutionFailure: boolean;

    glioblastomaDetailForm: Dtos.GlioblastomaDetailForm
    lookups: Dtos.Lookup[];
    validationFailures: Dtos.ResponseError[]

    loadingGlioblastomaDetailForm: boolean;
    loadGlioblastomaDetailFormSuccess: boolean;
    loadGlioblastomaDetailFormFailure: boolean;

    savingGlioblastomaDetailForm: boolean;
    saveGlioblastomaDetailFormSuccess: boolean;
    saveGlioblastomaDetailFormFailure: boolean;

    creatingGlioblastomaDetailForm: boolean;
    createGlioblastomaDetailFormSuccess: boolean;
    createGlioblastomaDetailFormFailure: boolean;

    messageModalOpen: boolean;
}

type GlioblastomaDetailFormPageProps = IGlioblastomaDetailFormPageProps & IGlioblastomaDetailFormPageActions;

const formName: string = "GlioblastomaDetailForm";
const reduxFormName: string = "reduxForms.glioblastomaDetailForm";

const subTableInputLabelClass: string = 'col-form-label col-sm-4 pr-0';
const subTableInputFieldClass: string = 'col-sm-8';
const subTableInputGroupClass: string = 'row mb-4';

const groupClassNames: string = 'form-group row border border-bottom-1 border-top-0 pb-4 pt-4';
const questionLabelClassNames: string = 'col-form-label col-sm-8';
const answerClassNames: string = 'col-sm-4 px-4';

const subQuestionLabelClassNames: string = questionLabelClassNames + ' pl-12'


class GlioblastomaDetailFormPage extends React.PureComponent<GlioblastomaDetailFormPageProps, any> {

    constructor(props: GlioblastomaDetailFormPageProps) {
        super(props);

        this.clearPatient = this.clearPatient.bind(this);
        this.clearInstitution = this.clearInstitution.bind(this);
        this.clearGlioblastomaDetailForm = this.clearGlioblastomaDetailForm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadPatient,
            identifier,
            institutionCode,
            loadInstitution,
            loadGlioblastomaDetailForm,
            createGlioblastomaDetailForm
        } = this.props;

        if (identifier) {
            loadPatient(identifier);
            loadGlioblastomaDetailForm(identifier);
        }
        else if (!identifier) {
            createGlioblastomaDetailForm();
        }
        if (institutionCode) {
            loadInstitution(institutionCode);
        }
    }

    componentWillReceiveProps(nextProps: GlioblastomaDetailFormPageProps) {
    }

    componentDidUpdate(prevProps: GlioblastomaDetailFormPageProps) {
        const {
            patient,
            loadForm,
            loadPatient,
            loadingPatient,
            loadPatientSuccess,
            loadPatientById,
            identifier,
            institutionCode,
            loadInstitution,
            loadingGlioblastomaDetailForm,
            loadGlioblastomaDetailFormSuccess,
            loadGlioblastomaDetailFormFailure,
            savingGlioblastomaDetailForm,
            saveGlioblastomaDetailFormSuccess,
            saveGlioblastomaDetailFormFailure,
            creatingGlioblastomaDetailForm,
            createGlioblastomaDetailFormSuccess,
            createGlioblastomaDetailFormFailure,
            createGlioblastomaDetailForm,
            glioblastomaDetailForm,
            navigateReplace,
            validationFailures,
            form,
            reduxFormState,
            navigate,
            toggleMessageModal,

        } = this.props;

        if (!loadingPatient && prevProps.loadingPatient) {
            if (loadPatientSuccess && !identifier) {
                if (form.saveAndReturn) {
                    navigate("/registration/" + institutionCode + "/" + (patient.registrationNumber ? patient.registrationNumber : patient.temporaryNumber) + "/patient-summary");
                }
                else {
                    navigateReplace("/registration/" + institutionCode + "/" + (patient.registrationNumber ? patient.registrationNumber : patient.temporaryNumber) + "/pre-registration");
                }
            }

        }

        if (identifier && prevProps.identifier != identifier) {
            loadPatient(identifier);
        }
        else if (!identifier && prevProps.identifier) {
            createGlioblastomaDetailForm();
        }

        if (institutionCode && prevProps.institutionCode != institutionCode) {
            loadInstitution(institutionCode);
        }


        if (!loadingGlioblastomaDetailForm && prevProps.loadingGlioblastomaDetailForm) {
            if (loadGlioblastomaDetailFormSuccess) {
                this.loadForm();
            }
            else {

            }
        }

        if (!savingGlioblastomaDetailForm && prevProps.savingGlioblastomaDetailForm) {
            if (saveGlioblastomaDetailFormSuccess) {
                if (validationFailures && validationFailures.length > 0) {

                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                    toggleMessageModal();

                }
                else {

                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                }

                if (form.saveAndReturn && identifier) {

                    navigate("/registration/" + institutionCode + "/" + identifier + "/patient-summary")
                }
                else if (!form.saveAndReturn) {

                    this.loadForm();
                }

                if (!identifier) {

                    loadPatientById(glioblastomaDetailForm.patientId);
                }
            }
            else {

                Alert.error(
                    <NotificationAlert
                        alertContent={renderRegistrationFormSaveError()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
        }

        if (!creatingGlioblastomaDetailForm && prevProps.creatingGlioblastomaDetailForm) {
            if (createGlioblastomaDetailFormSuccess) {
                this.loadForm();
            }
            else {

            }
        }
    }

    componentWillUpdate(nextProps: GlioblastomaDetailFormPageProps) {
    }

    componentWillUnmount() {

        const {
            resetForm,
            loadForm
        } = this.props

        this.clearInstitution();
        this.clearPatient();
        this.clearGlioblastomaDetailForm();
        loadForm(reduxFormName, initialGlioblastomaDetailFormState);
        resetForm(reduxFormName);
    }

    render() {

        const {
            loadingPatient,
            savingGlioblastomaDetailForm,
            loadingInstitution,
            loadingGlioblastomaDetailForm,
            loadGlioblastomaDetailFormSuccess,
            createGlioblastomaDetailFormSuccess,
            creatingGlioblastomaDetailForm
        } = this.props



        return <RestrictedLayout
            subMenuItems={this.createSubMenuItems()}
            loading={loadingPatient || loadingInstitution || loadingGlioblastomaDetailForm || creatingGlioblastomaDetailForm}
            saving={savingGlioblastomaDetailForm}
        >
            {this.renderContent()}
        </RestrictedLayout>;
    }

    renderContent() {
        const {
            form,
            patient,
            lookups,
            validationFailures,
            loadGlioblastomaDetailFormSuccess,
            createGlioblastomaDetailFormSuccess,
            saveGlioblastomaDetailFormSuccess,
            reduxFormState,
            formState,
            messageModalOpen,
            toggleMessageModal,
            savingGlioblastomaDetailForm,
            formProperties,
            changeForm
        } = this.props;


        const formDisabled: boolean = (formState && formState.formState == Dtos.RegistrationFormStatus.Disabled) || (patient && patient.status == Dtos.PatientStatus.Ineligible) || savingGlioblastomaDetailForm;
        
        let group1: boolean = (patient && patient.registrationGroup != undefined && patient.registrationGroup == 0);
        let group2: boolean = (patient && patient.registrationGroup != undefined && patient.registrationGroup == 1);
        
        let group1ClassNames = groupClassNames + (group1 ? "" : " hide-component");
        let group1HeaderClassNames = "row p-4 border border-top-0 border-left-0 border-right-0" + (group1 ? "" : " hide-component");
        let group1SubHeaderClassNames = group1 ? "form-group row d-block border border-bottom-1 border-top-0 no-gutter" : " hide-component";
        let group2ClassNames = groupClassNames + (group2 ? "" : " hide-component");
        let group2HeaderClassNames = "row p-4 border border-top-0 border-left-0 border-right-0" + (group2 ? "" : " hide-component");
        let group2SubHeaderClassNames = group2 ? "form-group row d-block border border-bottom-1 border-top-0 no-gutter" : " hide-component";
        
        const {
            plannedOtherSystemicTreatmentNone,
            participatingInAnyOtherTrialYes,
            isAdjuvantChemotherapyPlannedUsingTMZYes,
            temozolomideOngoing,
            otherSystemicTreatmentNone,
            otherSystemicTreatmentOngoing,
            radiotherapyOngoing
        } = this.handleDisabledValues();

        console.log('plannedOtherSystemicTreatmentNone', plannedOtherSystemicTreatmentNone);

        const formComponents: { [index: string]: RegistrationFormComponent } = {
            dateOfSurgeryForGBM: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                validationMessageAbove: true,
                inputDisabled: formDisabled,               
                inputProps: {
                    maxDate: new Date()
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            extentOfResections: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "extentOfResections", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            isTissueAvailableForBiologicalSubStudy: {
                type: RegistrationComponent.RegistrationControl,
                inputType: RadioButtonSetFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "isTissueAvailableForBiologicalSubStudy", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            idH1StatusFromIHC: {
                type: RegistrationComponent.RegistrationControl,
                inputType: RadioButtonSetFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "idH1StatusFromIHC", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            groupOneHeading: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group1HeaderClassNames}>
                    <h2>Chemoradiation Therapy (Chemo-RT) details: Group One</h2>
                </div>,
                groupClassName: group1ClassNames
            },
            plannedChemoRTStartDate: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group1ClassNames
            },
            expectedChemoRTCompletion: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group1ClassNames
            },
            plannedDoseOfTemozolomideGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group1SubHeaderClassNames}>
                    {
                        renderFormControls(
                            form,
                            "GlioblastomaDetailForm",
                            {
                                plannedDoseOfTemozolomideHeading: {
                                    type: RegistrationComponent.RegistrationElement,
                                    component: <div className="border-0 d-flex pt-4 pl-4">
                                        <h3>Planned dose of Temozolomide (TMZ)</h3>
                                    </div>
                                },
                                plannedDoseOfTemozolomide: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: SelectFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "plannedDoseOfTemozolomide", lookups))
                                    },
                                    groupClassName: "border-0 d-flex pt-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames
                                },
                                plannedDoseOfTemozolomideTotal: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: NumberFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        precision: 0,
                                        addOnRight: <span>mg</span>
                                    },
                                    groupClassName: "border-0 d-flex pt-4 pb-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )
                    }
                </div>
            },
            plannedTemozolomideFrequency: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "plannedTemozolomideFrequency", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group1ClassNames
            },
            plannedOtherSystemicTreatment: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "plannedOtherSystemicTreatment", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group1ClassNames,
            },
            plannedOtherSystemicTreatmentName: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: plannedOtherSystemicTreatmentNone ? "hide-component" : group1ClassNames
            },
            plannedOtherSystemicTreatmentDose: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: plannedOtherSystemicTreatmentNone ? "hide-component" : group1ClassNames
            },
            plannedOtherSystemicTreatmentRoute: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "plannedOtherSystemicTreatmentRoute", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: plannedOtherSystemicTreatmentNone ? "hide-component" : group1ClassNames
            },
            plannedOtherSystemicTreatmentFrequency: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: plannedOtherSystemicTreatmentNone ? "hide-component" : group1ClassNames
            },
            plannedRTPrescription: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "plannedRTPrescription", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group1ClassNames
            },
            groupTwoHeading: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group2HeaderClassNames}>
                    <h2>Chemoradiation Therapy (Chemo-RT) details: Group Two</h2>
                </div>
            },
            temozolomideStartDate: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames
            },
            temozolomideStopDateGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group2SubHeaderClassNames}>
                    {
                        renderFormControls(
                            form,
                            "GlioblastomaDetailForm",
                            {
                                temozolomideStopDate: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: DatePickerFormInputFabric,
                                    inputDisabled: formDisabled || temozolomideOngoing,
                                    groupClassName: "border-0 d-flex pt-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames
                                },
                                temozolomideOngoing: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: CheckboxFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        label: "Ongoing"
                                    },
                                    inputLabel: " ",
                                    changeAction: (model, value, form, parentModel) => {
                                        changeForm(model, value);
    
                                        if (value != false) {
                                            changeForm(reduxFormName + parentModel + '.temozolomideStopDate', null);
                                        }
                                    },
                                    groupClassName: "border-0 d-flex pt-4 pb-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )
                    }
                </div>
            },
            temozolomideDoseGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group2SubHeaderClassNames}>
                    {
                        renderFormControls(
                            form,
                            "GlioblastomaDetailForm",
                            {
                                plannedDoseOfTemozolomideHeading: {
                                    type: RegistrationComponent.RegistrationElement,
                                    component: <div className="border-0 d-flex pt-4 pl-4">
                                        <h3>Temozolomide (TMZ) Dose</h3>
                                    </div>
                                },
                                temozolomideDose: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: SelectFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "temozolomideDose", lookups))
                                    },
                                    groupClassName: "border-0 d-flex pt-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames
                                },
                                temozolomideDoseTotal: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: NumberFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        precision: 0,
                                        addOnRight: <span>mg</span>
                                    },
                                    groupClassName: "border-0 d-flex pt-4 pb-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )
                    }
                </div>
            },
            temozolomideFrequency: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "temozolomideFrequency", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames
            },
            otherSystemicTreatment: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "otherSystemicTreatment", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames
            },
            otherSystemicTreatmentName: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: otherSystemicTreatmentNone ? "hide-component" : group2ClassNames
            },
            otherSystemicTreatmentStartDate: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: otherSystemicTreatmentNone ? "hide-component" : group2ClassNames
            },
            otherSystemicTreatmentStopDateGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={otherSystemicTreatmentNone ? "hide-component" : group2SubHeaderClassNames}>
                    {
                        renderFormControls(
                            form,
                            "GlioblastomaDetailForm",
                            {
                                otherSystemicTreatmentStopDate: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: DatePickerFormInputFabric,
                                    inputDisabled: formDisabled || otherSystemicTreatmentOngoing,
                                    groupClassName: "border-0 d-flex pt-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames
                                },
                                otherSystemicTreatmentOngoing: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: CheckboxFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        label: "Ongoing"
                                    },
                                    inputLabel: " ",
                                    changeAction: (model, value, form, parentModel) => {
                                        changeForm(model, value);
    
                                        if (value != false) {
                                            changeForm(reduxFormName + parentModel + '.otherSystemicTreatmentStopDate', null);
                                        }
                                    },
                                    groupClassName: "border-0 d-flex pt-4 pb-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )
                    }
                </div>
            },
            otherSystemicTreatmentDose: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: otherSystemicTreatmentNone ? "hide-component" : group2ClassNames
            },
            otherSystemicTreatmentRoute: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "otherSystemicTreatmentRoute", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: otherSystemicTreatmentNone ? "hide-component" : group2ClassNames
            },
            otherSystemicTreatmentFrequency: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: otherSystemicTreatmentNone ? "hide-component" : group2ClassNames
            },
            radiotherapyStartDate: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames,              
                inputProps: {
                    maxDate: new Date()
                },
            },
            radiotherapyStopDateGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className={group2SubHeaderClassNames}>
                    {
                        renderFormControls(
                            form,
                            "GlioblastomaDetailForm",
                            {
                                radiotherapyStopDate: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: DatePickerFormInputFabric,
                                    inputDisabled: formDisabled || radiotherapyOngoing,
                                    groupClassName: "border-0 d-flex pt-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,              
                                    inputProps: {
                                        maxDate: new Date()
                                    },
                                },
                                radiotherapyOngoing: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: CheckboxFormInput,
                                    inputDisabled: formDisabled,
                                    inputProps: {
                                        label: "Ongoing"
                                    },
                                    inputLabel: " ",
                                    changeAction: (model, value, form, parentModel) => {
                                        changeForm(model, value);
    
                                        if (value != false) {
                                            changeForm(reduxFormName + parentModel + '.radiotherapyStopDate', null);
                                        }
                                    },
                                    groupClassName: "border-0 d-flex pt-4 pb-4",
                                    labelClassName: questionLabelClassNames,
                                    fieldClassName: answerClassNames,
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )
                    }
                </div>
            },
            radiotherapyPrescription: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "radiotherapyPrescription", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames
            },
            adjuvantChemotherapyDetailsHeading: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className="border-0 d-flex pt-4 ">
                    <h3>Adjuvant Chemotherapy details</h3>
                </div>
            },
            isAdjuvantChemotherapyPlannedUsingTMZ: {
                type: RegistrationComponent.RegistrationControl,
                inputType: RadioButtonSetFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "isAdjuvantChemotherapyPlannedUsingTMZ", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            plannedStartDate: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                inputDisabled: formDisabled || group1 || !isAdjuvantChemotherapyPlannedUsingTMZYes,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: group2ClassNames
            },
            participatingInAnyOtherTrial: {
                type: RegistrationComponent.RegistrationControl,
                inputType: RadioButtonSetFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("GlioblastomaDetailForm", "participatingInAnyOtherTrial", lookups))
                },
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames
            },
            participatingInAnyOtherTrialName: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled || !participatingInAnyOtherTrialYes,
                labelClassName: questionLabelClassNames,
                fieldClassName: answerClassNames,
                groupClassName: !participatingInAnyOtherTrialYes ? "hide-component" : groupClassNames
            },
        };

        return <div>
            <h1>Glioblastoma Detail Form</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "glioblastomaDetailForm", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit Form
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit Form And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>
        </div>
    }

    clearPatient() {
        this.props.clearPatient();
    }

    clearInstitution() {
        this.props.clearInstitution();
    }

    clearGlioblastomaDetailForm() {
        this.props.clearGlioblastomaDetailForm();
    }

    onCancel() {
        const {
            navigate,
            resetForm,
            institutionCode,
            identifier
        } = this.props

        if (identifier) {

            navigate("/registration/" + institutionCode + "/" + identifier + "/patient-summary");
        }
        else {
            navigate("/registration/" + institutionCode);
        }

    }

    createSubMenuItems(): INavItem[] {

        const {
            identifier,
            institutionCode,
            institution,
            patient
        } = this.props

        let institutionName: string = ''
        if (institution) {
            institutionName = institution.institutionName;
        }

        let displayIdentifier: string = ''
        if (patient) {
            if (patient.registrationNumber) {
                displayIdentifier = patient.registrationNumber;
            }
            else if (patient.siteNumber) {
                displayIdentifier = patient.siteNumber.toString();
            }
        }

        return [
            {
                icon: <FontAwesomeIcon fixedWidth icon={FontAwesomeIcons.Solid.BUILDING} />,
                title: institutionName,
                url: "/registration/" + institutionCode
            },
            {
                icon: <FontAwesomeIcon fixedWidth icon={FontAwesomeIcons.Solid.USER} />,
                title: displayIdentifier,
                url: identifier ? "/registration/" + institutionCode + "/" + identifier + "/patient-summary" : undefined
            },
            {
                icon: <FontAwesomeIcon fixedWidth icon={FontAwesomeIcons.Solid.FILE_ALT} />,
                title: "Glioblastoma Detail Form"
            }
        ]
    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    priorTreatmentsRequired(data: Dtos.GlioblastomaDetailForm): boolean {
        var returnBool: boolean = false;
        return returnBool;
    }

    handleDisabledValues() {
        const {
            form
        } = this.props

        let plannedOtherSystemicTreatmentNone: boolean = true;
        if (form.plannedOtherSystemicTreatment != undefined && form.plannedOtherSystemicTreatment !== 0) {
            plannedOtherSystemicTreatmentNone = false;
        }

        let participatingInAnyOtherTrialYes: boolean = false;
        if (form.participatingInAnyOtherTrial != undefined && form.participatingInAnyOtherTrial === 0) {
            participatingInAnyOtherTrialYes = true;
        }

        
        let isAdjuvantChemotherapyPlannedUsingTMZYes: boolean = false;
        if (form.isAdjuvantChemotherapyPlannedUsingTMZ != undefined) {
            isAdjuvantChemotherapyPlannedUsingTMZYes = form.isAdjuvantChemotherapyPlannedUsingTMZ === 0;
        }

        let temozolomideOngoing: boolean = false;
        if (form.temozolomideOngoing != undefined) {
            temozolomideOngoing = form.temozolomideOngoing;
        }

        let otherSystemicTreatmentNone: boolean = true;
        if (form.otherSystemicTreatment != undefined && form.otherSystemicTreatment !== 0) {
            otherSystemicTreatmentNone = false;
        }

        let otherSystemicTreatmentOngoing: boolean = false;
        if (form.otherSystemicTreatmentOngoing != undefined) {
            otherSystemicTreatmentOngoing = form.otherSystemicTreatmentOngoing;
        }

        let radiotherapyOngoing: boolean = false;
        if (form.radiotherapyOngoing != undefined) {
            radiotherapyOngoing = form.radiotherapyOngoing;
        }

        return {
            plannedOtherSystemicTreatmentNone,
            participatingInAnyOtherTrialYes,
            isAdjuvantChemotherapyPlannedUsingTMZYes,
            temozolomideOngoing,
            otherSystemicTreatmentNone,
            otherSystemicTreatmentOngoing,
            radiotherapyOngoing
        }
    }


    handleOnSubmit(data: Dtos.GlioblastomaDetailForm) {

        const {
            saveGlioblastomaDetailForm,
            institutionCode,
            identifier,
            validationFailures,
            changeForm

        } = this.props;

        if (data && institutionCode) {

            const isDisabled = this.handleDisabledValues();

            let changes: Dtos.GlioblastomaDetailForm = {} as Dtos.GlioblastomaDetailForm;
            saveGlioblastomaDetailForm(Object.assign({ ...data }, changes), institutionCode, identifier);
        }

    }


    handleOnSubmitFailed(data: Dtos.GlioblastomaDetailForm) {

        const { institutionCode,
            identifier,
        } = this.props;

        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    toggleMessageModal() {
        const {
            toggleMessageModal
        } = this.props

        // eslint-disable-next-line
        toggleMessageModal;
    }

    loadForm() {
        const {
            loadForm,
            glioblastomaDetailForm
        } = this.props

        let extraData: Dtos.GlioblastomaDetailForm = {} as Dtos.GlioblastomaDetailForm;

        loadForm(reduxFormName, Object.assign({ ...glioblastomaDetailForm }, extraData));
    }
}

const mapStateToProps = (state: IFigState, ownProps: GlioblastomaDetailFormPageProps): IGlioblastomaDetailFormPageProps => {

    const glioblastomaDetailForm = !(state.registrationForms.glioblastomaDetailForms.formData instanceof Array) ? state.registrationForms.glioblastomaDetailForms.formData : undefined;

    return {
        match: ownProps.match,
        history: ownProps.history,
        location: state.routing.location,
        identifier: ownProps.match ? ownProps.match.params.identifier : undefined,
        institutionCode: ownProps.match ? ownProps.match.params.institutionCode : undefined,

        patient: !(state.patients.data instanceof Array) ? state.patients.data : undefined,
        loadingPatient: state.patients.loadState && state.patients.loadState.status == RequestState.Pending,
        loadPatientSuccess: state.patients.loadState && state.patients.loadState.status == RequestState.Success,
        loadPatientFailure: state.patients.loadState && state.patients.loadState.status == RequestState.Failure,

        institution: !(state.institutions.data instanceof Array) ? state.institutions.data : undefined,
        loadingInstitution: state.institutions.loadState && state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionSuccess: state.institutions.loadState && state.institutions.loadState.status == RequestState.Success,
        loadInstitutionFailure: state.institutions.loadState && state.institutions.loadState.status == RequestState.Failure,

        glioblastomaDetailForm: glioblastomaDetailForm,
        lookups: state.registrationForms.glioblastomaDetailForms.lookups,
        loadingGlioblastomaDetailForm: state.registrationForms.glioblastomaDetailForms.loadState &&
            (state.registrationForms.glioblastomaDetailForms.loadState.status == RequestState.Pending ||
                (state.registrationForms.glioblastomaDetailForms.loadState.status == RequestState.None &&
                    state.registrationForms.glioblastomaDetailForms.createState.status == RequestState.None)),
        loadGlioblastomaDetailFormSuccess: state.registrationForms.glioblastomaDetailForms.loadState && state.registrationForms.glioblastomaDetailForms.loadState.status == RequestState.Success,
        loadGlioblastomaDetailFormFailure: state.registrationForms.glioblastomaDetailForms.loadState && state.registrationForms.glioblastomaDetailForms.loadState.status == RequestState.Failure,

        savingGlioblastomaDetailForm: state.registrationForms.glioblastomaDetailForms.saveState && state.registrationForms.glioblastomaDetailForms.saveState.status == RequestState.Pending,
        saveGlioblastomaDetailFormSuccess: state.registrationForms.glioblastomaDetailForms.saveState && state.registrationForms.glioblastomaDetailForms.saveState.status == RequestState.Success,
        saveGlioblastomaDetailFormFailure: state.registrationForms.glioblastomaDetailForms.saveState && state.registrationForms.glioblastomaDetailForms.saveState.status == RequestState.Failure,

        creatingGlioblastomaDetailForm: state.registrationForms.glioblastomaDetailForms.createState && state.registrationForms.glioblastomaDetailForms.createState.status == RequestState.Pending,
        createGlioblastomaDetailFormSuccess: state.registrationForms.glioblastomaDetailForms.createState && state.registrationForms.glioblastomaDetailForms.createState.status == RequestState.Success,
        createGlioblastomaDetailFormFailure: state.registrationForms.glioblastomaDetailForms.createState && state.registrationForms.glioblastomaDetailForms.createState.status == RequestState.Failure,

        form: state.reduxForms.glioblastomaDetailForm,
        formState: state.registrationForms.glioblastomaDetailForms.formState,
        formProperties: state.registrationForms.glioblastomaDetailForms.formProperties,

        reduxFormState: state.reduxForms.formState.glioblastomaDetailForm,
        validationFailures: glioblastomaDetailForm && glioblastomaDetailForm.id ?
            state.registrationForms.glioblastomaDetailForms.validationFailures :
            undefined,

        messageModalOpen: state.glioblastomaDetailFormPage.messageModalOpen
    };
};

const mapDispatchToProps = (dispatch): IGlioblastomaDetailFormPageActions => {
    return {
        loadPatient: bindActionCreators(PatientActions.LoadPatientByIdentifier, dispatch),
        loadPatientById: bindActionCreators(PatientActions.LoadPatientById, dispatch),
        clearPatient: bindActionCreators(PatientActions.Clear, dispatch),

        loadInstitution: bindActionCreators(InstitutionActions.LoadInstitutionByInstitutionCode, dispatch),
        clearInstitution: bindActionCreators(InstitutionActions.Clear, dispatch),

        loadGlioblastomaDetailForm: bindActionCreators(GlioblastomaDetailFormActions.LoadGlioblastomaDetailFormByPatientIdentifier, dispatch),
        saveGlioblastomaDetailForm: bindActionCreators(GlioblastomaDetailFormActions.SaveGlioblastomaDetailForm, dispatch),
        createGlioblastomaDetailForm: bindActionCreators(GlioblastomaDetailFormActions.CreateGlioblastomaDetailForm, dispatch),
        clearGlioblastomaDetailForm: bindActionCreators(GlioblastomaDetailFormActions.Clear, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        toggleMessageModal: bindActionCreators(GlioblastomaDetailFormPageActions.toggleMessageModal, dispatch)
    }
};

export default
    connect(mapStateToProps, mapDispatchToProps)(GlioblastomaDetailFormPage);
